<template>
  <section class="hero is-warning">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          Oops!
        </h1>
        <h2 class="subtitle">
          This page does not exist.
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'not-found'
}
</script>

<style scoped>
.hero {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue